import React from 'react';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import Tabs from 'housecall-ui/dist/DesignSystem/Navigation/Tabs/Tabs';
import HousecallThemeProvider from 'housecall-ui/dist/DesignSystem/Styles/HousecallThemeProvider';
import SettingsIcon from 'housecall-ui/dist/IconsAndImages/Icons/Settings';
import IconButton from 'housecall-ui/dist/library/Buttons/IconButton';
import { QueryClientProvider } from 'resources/ReactQuery/QueryClientProvider';

import RedirectTo from 'components/Common/RedirectTo';
import GlobalSearchContainer from 'components/Toolbar/v2/GlobalSearch/GlobalSearchContainer';

import { NavProps } from '../types';

import AddButton from './AddButton';
import AvatarMenu from './AvatarMenu';
import TabLink from './TabLink';
import LabelWithBadge from './LabelWithBadge';

const DesktopNav = ({ onTabChange, activeTab, tabs = [] }: NavProps) => {
  return (
    <Grid data-testid="DesktopNav-root" container alignItems="center" spacing={1} wrap="nowrap">
      <Grid item xs={6}>
        <Tabs version="v2" onChange={onTabChange} value={activeTab} width="full">
          {tabs.map(({ label, path, badgeValue: badgeCount }, index) => (
            <TabLink
              key={path}
              version="v2"
              href={path}
              label={<LabelWithBadge badgeCount={badgeCount}>{label}</LabelWithBadge>}
              tabIndex={0}
              selected={activeTab === index}
            />
          ))}
        </Tabs>
      </Grid>
      <Grid container item xs="auto" spacing={1} alignItems="center" justify="flex-end" wrap="nowrap">
        <Grid item>
          <HousecallThemeProvider mode="light">
            <QueryClientProvider>
              <GlobalSearchContainer responsive />
            </QueryClientProvider>
          </HousecallThemeProvider>
        </Grid>
        <Grid item>
          <AddButton />
        </Grid>
        <Grid item>
          <IconButton aria-label="Settings" component="a" onClick={() => RedirectTo.accountSettings()}>
            <SettingsIcon />
          </IconButton>
        </Grid>
        <Grid item>
          <AvatarMenu />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default DesktopNav;
